import { AC_BASE_REQUEST_STATUS } from 'models/create-request';
import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from 'routers/routes';
import { useAppDispatch, useAppSelector } from 'store/hook';
import {
  initialRequestState,
  updateOverallDataSubmit,
  updateStepTrial,
  updateUrlServiceAgreementPDF,
} from 'store/reducers/trial-request';
import { LabelSubTitle, LabelTitle } from '../styles';
import RequestAddChildren from './components/RequestAddChildren';
import RequestDetail from './components/RequestDetail';
import RequestPayment from './components/RequestPayment';
import RequestSuccess from './components/RequestSuccess';
import { CreateRequestContainer, RequestHeader } from './styles';

function CreateRequest() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { baseRequest } = useAppSelector((state) => state.overview);
  const { stepBaseRequest } = useAppSelector((state) => state.baseRequest);

  useEffect(() => {
    if (!baseRequest) return;
    const isSuccessRequest =
      baseRequest.status !== AC_BASE_REQUEST_STATUS.PAYMENT_FAILED &&
      baseRequest.status !== AC_BASE_REQUEST_STATUS.PENDING_PAYMENT;

    if (isSuccessRequest) {
      navigate(APP_ROUTES.OVERVIEW.to);
      return;
    }
    // eslint-disable-next-line
  }, [baseRequest]);

  const getTitle = useMemo(() => {
    switch (stepBaseRequest) {
      case 1:
        return {
          title: 'Step 1: Add your children',
          subTitle: 'Add your child so we can assign the best sitter for you',
        };
      case 2:
        return {
          title: 'Step 2: Request details',
          subTitle: 'Let us know your request so we can find best matches',
        };
      case 3:
        return {
          title: 'Step 3: Payment',
          subTitle: 'This is a one time search fee to fulfill your request',
        };
      default:
        return {
          title: '',
          subTitle: '',
        };
    }
  }, [stepBaseRequest]);

  const getActiveUI = useMemo(() => {
    switch (stepBaseRequest) {
      case 1:
        return <RequestAddChildren />;
      case 2:
        return <RequestDetail />;
      case 3:
        return <RequestPayment />;
      default:
        return <RequestSuccess />;
    }
  }, [stepBaseRequest]);

  // clean up on unmount
  useEffect(() => {
    return () => {
      dispatch(updateStepTrial(initialRequestState.stepBaseRequest));
      dispatch(updateOverallDataSubmit(initialRequestState.overallDataSubmit));
      dispatch(
        updateUrlServiceAgreementPDF(
          initialRequestState.urlServiceAgreementPDF,
        ),
      );
    };
    // eslint-disable-next-line
  }, []);

  return (
    <CreateRequestContainer>
      <RequestHeader>
        <LabelTitle>{getTitle.title}</LabelTitle>
        <LabelSubTitle>{getTitle.subTitle}</LabelSubTitle>
      </RequestHeader>
      {getActiveUI}
    </CreateRequestContainer>
  );
}

export default CreateRequest;
